import { useRef } from 'react';
import { Box, Tooltip } from '@mui/material';
import { TOP_LEVEL_BUSINESS_UNIT } from 'pages/AuditLogs/constants';
import { FlatOption } from 'pages/AuditLogs/types';
import { useRevealEllipsisInTooltip } from 'services/hooks';
import { textWithEllipsisStyle } from 'utilities';

const OptionContent = ({ option, paddingLeft }: { option: FlatOption; paddingLeft: number | string }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { tooltipRef, width } = useRevealEllipsisInTooltip();
  const containerWidth = containerRef.current?.offsetWidth || 0;
  const shouldShowTooltip = width > containerWidth;

  return (
    <Box ref={containerRef} sx={{ width: '100%' }}>
      <Tooltip title={shouldShowTooltip ? option.label : ''} placement="top">
        <Box
          ref={tooltipRef}
          sx={{
            ...textWithEllipsisStyle,
            paddingLeft,
            fontWeight: TOP_LEVEL_BUSINESS_UNIT.has(option.kind) ? 600 : 400,
            height: '1.3em',
            width: '100%',
          }}>
          {option.label}
        </Box>
      </Tooltip>
    </Box>
  );
};

export default OptionContent;
